export enum ConnectionStatusState {
    Online = 'ONLINE',
    Offline = 'OFFLINE',
}

export class ConnectionStatus {

    current: ConnectionStatusState | null = $state(null);

    offlineAndCheckFailed = false

    constructor(private readonly captureMessage: (message: string) => void) {}

    private handleOnline() {
        this.current = ConnectionStatusState.Online

        if (this.offlineAndCheckFailed) {
            // this.captureMessage(`ONLINE again - WAS OFFLINE`)
            this.offlineAndCheckFailed = false;
        }
    }

    private async handleOffline() {
        try {
            const response = await fetch('/check-internet-connection.txt', {
                method: 'HEAD',
                cache: 'no-cache',
            })

            if (response.ok) {
                // this.captureMessage(`OFFLINE - check response.ok`)
            } else {
                // this.captureMessage(`OFFLINE - check response NOT ok - ${response.status} ${response.statusText}`)
                this.current = ConnectionStatusState.Offline
                this.offlineAndCheckFailed = true
            }

        } catch (error) {
            this.current = ConnectionStatusState.Offline
            this.offlineAndCheckFailed = true

            // this.captureMessage(`OFFLINE - check internet connection failed`)
        }
    }

    init() {
        if (navigator.onLine) {
            this.handleOnline()
        } else {
            this.handleOffline()
        }

        window.addEventListener('online', this.handleOnline.bind(this));
        window.addEventListener('offline', this.handleOffline.bind(this));
    }
}